import React, { useState, useCallback, useMemo, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Grid,
  CircularProgress,
} from "@mui/material";

import styles from "./Dashboard.module.css";
import BackArrow from "../../../assets/images/blue-back-arrow.svg";
import Edit from "../../../assets/images/notelIcon.svg";
import SliderIcon from "../../../assets/images/sliderIcon.svg";
import MenuIcon from "../../../assets/images/menu.svg";
import RenameIcon from "../../../assets/images/rename.svg";
import DeleteIcon from "../../../assets/images/grey-delete.svg";
import TableImg from "../../../assets/images/screenshot1.svg";
import GraphsImg from "../../../assets/images/screenshot2.svg";
import DeleteChatDialog from "Samarth Module/components/SamarthAi/DeleteChatDialog";
import RenameDialog from "Samarth Module/components/SamarthAi/RenameDialog";
import { FeedbackDialog } from "Samarth Module/components/SamarthAi/FeedbackDialog";
import { useLocation, useNavigate } from "react-router-dom";
import PromtsHistory from "Samarth Module/components/SamarthAi/PromtsHistory";
import {
  createNewDashboardV2,
  deleteDashboardV2,
  getConversationIdV2,
  getDashboardList,
  renameDashboardV2,
} from "Samarth Module/api/samarthAiAPI";
import BotIcon from "../../../assets/images/dhBotIcon.svg";
import { getConversationListV2 } from "Samarth Module/api/samarthAiAPI";
import ReusableSnackbar from "Samarth Module/components/SamarthAi/ReusableSnackbar";
import DashboardDefault from "../../../assets/images/Thumbnail-dashboard.svg";
import DashboardFilled from "../../../assets/images/dashboard-filled.svg";
import ExpandIcon from "../../../assets/images/expandmore.svg";
import ExpandLessIcon from "../../../assets/images/expandless.svg";
const MenuStyles = {
  "& .MuiMenu-paper": {
    background: "linear-gradient(180deg, #C2E0FF -119.85%, #FFFFFF 100%)",
    border: "1px solid #C2E0FF",
    borderRadius: "10px",
    p: "2px",
    maxWidth: { md: "100px", lg: "130px" },
    width: "100%",
    "& .MuiMenu-list": {
      p: 0,
      "& .MuiMenuItem-root": {
        p: "12px",
        borderBottom: "1px solid #D9E1E7",
        fontSize: { md: "10px", lg: "14px" },
        lineHeight: "140%",
        color: "#667F93",
        borderRadius: "4px",
        "&:hover": {
          background: "#fff",
        },
        "&:last-child": {
          borderBottom: 0,
        },
      },
    },
  },
};

export default function MyDashboardsList({
  view,
  onDashboardSelect,
  conversationId,
}) {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [selectedItem] = useState("");
  const [chatData, setChatData] = useState({});
  const [openRenameDialog, setOpenRenameDialog] = useState(false);
  const [renameCardId, setRenameCardId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [newDashboardName, setNewDashboardName] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  const [conversationList, setConversationList] = useState([]);
  const navigate = useNavigate();
  const [pageloading, setPageloading] = useState(false);
  const [hasNext, setHasNext] = useState(true);
  const [page, setPage] = useState(1);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [hasLoadedConversations, setHasLoadedConversations] = useState(false);
  const [hasNextChat, setHasNextChat] = useState(true);
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("UserInfo"))?.user_info,
    [],
  );
  const formatConversationMessages = (messages) => {
    const formatted = [];

    messages.forEach((msg) => {
      // Set spaceId/messageId if available
      // if (msg?.space_id) setSpaceId(msg.space_id);
      // setMessageId(msg?.message_id);

      // Extract graph data if present
      const graphPayload = msg?.graph_data;
      const graph = graphPayload?.graph_data;

      // Determine if graph should be shown
      const statement = msg.response_attachment?.statement_response;
      const hasData =
        msg.response_attachment &&
        (Array.isArray(msg.response_attachment)
          ? msg.response_attachment.length > 0
          : Object.keys(msg.response_attachment).length > 0);
      const isSuccess = statement?.status?.state === "SUCCEEDED";
      const shouldShowGraph = hasData && isSuccess;

      // 👉 USER MESSAGE
      if (msg.question) {
        formatted.push({
          id: msg.message_id,
          sender: "user",
          type: "text",
          text: msg.question,
          is_pinned: msg.is_pinned ?? false,
        });
      }

      // 👉 BOT RESPONSE
      if (msg.explanation || msg.response_attachment) {
        // Columns and rows for table type
        const columns = statement?.manifest?.schema?.columns || [];
        const rows = statement?.result?.data_array || [];

        if (statement) {
          // Table type message
          formatted.push({
            id: msg.message_id,
            sender: "bot",
            type: "table",
            text: msg.explanation || "",
            columns,
            rows,
            feedback: msg.feedback,
            showGraph: shouldShowGraph,

            // Always initialize viewMode and graphFetched
            viewMode: "table",
            graphFetched: !!graph, // true if graph exists
            loadingGraph: false,

            // Attach graph data if present
            graph: graph
              ? {
                  type: graphPayload?.type,
                  title: graph?.graph_title,
                  variant: graph?.variant,
                  xKey: graph?.data_points?.name,
                  yKey: graph?.data_points?.value,
                  data: graph?.graph_data || [],
                  styles: graph?.styles || {},
                }
              : null,
          });
        } else {
          // Text type message
          formatted.push({
            id: msg.message_id,
            sender: "bot",
            type: "text",
            text:
              msg.explanation ||
              msg.response_attachment ||
              "No response received",
            feedback: msg.feedback,
            showGraph: shouldShowGraph,

            // Always initialize viewMode and graphFetched
            viewMode: "table",
            graphFetched: !!graph,
            loadingGraph: false,

            graph: graph
              ? {
                  type: graphPayload?.type,
                  title: graph?.graph_title,
                  variant: graph?.variant,
                  xKey: graph?.data_points?.name,
                  yKey: graph?.data_points?.value,
                  data: graph?.graph_data || [],
                  styles: graph?.styles || {},
                }
              : null,
          });
        }
      }
    });

    // Add all formatted messages to state
    // setMessages((prev) => [...prev, ...formatted]);
  };
  const fetchConversations = async (pageNumber, force = false) => {
    if (!userInfo?.id) return;
    if (!force && !hasNext) return; // stop if no more pages

    try {
      setPageloading(true);

      const data = await getConversationListV2(pageNumber, {
        user_id: userInfo.id,
        user_name: userInfo.name,
        user_email: userInfo.email,
      });

      if (data?.conversation) {
        setConversationList((prev) => [...prev, ...data.conversation]);
      }

      setHasNext(data?.has_next);
    } catch (error) {
      console.error("Error fetching conversations:", error);
    } finally {
      setPageloading(false);
    }
  };
  const fetchConversationId = async (
    conversationId,
    pageNumber,
    force = false,
  ) => {
    if (!userInfo?.id) return;
    if (!force && !hasNextChat) return;
    try {
      setPageloading(true);
      const data = await getConversationIdV2(conversationId, pageNumber);
      if (data?.status) {
        formatConversationMessages(data.messages);
      }
      setHasNextChat(data?.has_next);
    } catch (error) {
      console.error("Error fetching conversations:", error);
    } finally {
      setPageloading(false);
    }
  };
  const openMenu = (event, id) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedId(id);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleRename = () => {
    const selectedCard = cards.find((card) => card.id === selectedId);

    setRenameCardId(selectedId);
    setEditValue(selectedCard?.title || "");
    setOpenRenameDialog(true);
    closeMenu();
  };
  const handleDeleteClick = () => {
    setDeleteItem(selectedItem);
    setOpenDeleteDialog(true);
    closeMenu();
  };

  const handleSaveRename = async (newTitle) => {
    if (!newTitle.trim()) {
      setError("Dashboard name cannot be empty");
      return;
    }
    try {
      const updatedCards = cards.map((card) =>
        card.id === renameCardId ? { ...card, title: newTitle } : card,
      );

      const payload = {
        dashboard_title: newTitle,
        user_id: userInfo.id,
        user_name: userInfo.name,
        user_email: userInfo.email,
        dashboard_id: selectedId,
      };

      await renameDashboardV2(payload);

      setCards(updatedCards);
      setOpenRenameDialog(false);
      setSuccessMessage("Dashboard Renamed Successfully");
      setSuccess(true); // show success snackbar
    } catch (error) {
      console.error("Error renaming dashboard:", error);
      setError("Failed to rename dashboard. Please try again.");
    }
  };

  const handleOpenDialog = useCallback(() => {
    setOpenDialog(true);
    setAnchorEl(null);
  }, []);
  const handleCloseDialog = useCallback(() => {
    setOpenDialog(false);
    setNewDashboardName("");
  }, []);
  const fetchDashboardCards = useCallback(async () => {
    if (!userInfo?.id) return;

    const payload = {
      user_id: userInfo.id,
      user_name: userInfo.name,
      user_email: userInfo.email,
    };

    try {
      setLoading(true);
      const response = await getDashboardList(payload);
      const formattedCards = response.dashboard_list.map((item) => ({
        id: item.dashboard_id,
        title: item.dashboard_title,
        image: item.type === "table" ? TableImg : GraphsImg,
        count: item.dashboard_views_count,
      }));
      setCards(formattedCards);
    } catch (error) {
      console.error("Error fetching dashboard list:", error);
    } finally {
      setLoading(false);
    }
  }, [userInfo]);
  const handleCreateDashboard = useCallback(async () => {
    const name = newDashboardName.trim();

    if (!name) {
      setError("Dashboard name cannot be empty");
      return;
    }

    if (!userInfo?.id) {
      setError("User info missing");
      return;
    }

    const existingTitles = new Set(
      cards.map((c) => (c.title || "").trim().toLowerCase()),
    );
    let uniqueName = name;
    if (existingTitles.has(name.toLowerCase())) {
      let i = 1;
      while (existingTitles.has(`${name} (${i})`.toLowerCase())) i++;
      uniqueName = `${name} (${i})`;
    }

    const payload = {
      dashboard_title: uniqueName,
      user_id: userInfo.id,
      user_name: userInfo.name,
      user_email: userInfo.email,
      dashboard_description: "dashboard description",
    };

    try {
      await createNewDashboardV2(payload);

      setSuccessMessage("Dashboard Created Successfully");
      setSuccess(true);
      setError("");
      setNewDashboardName("");
      setOpenDialog(false);

      await fetchDashboardCards();
    } catch (err) {
      console.error("Error creating dashboard:", err);
      setError("Failed to create dashboard. Please try again.");
    }
  }, [newDashboardName, userInfo, cards, fetchDashboardCards]);
  const loadMore = async () => {
    if (!hasNext || pageloading) return;
    const nextPage = page + 1;
    setPage(nextPage);
    await fetchConversations(nextPage);
  };
  const confirmDelete = async () => {
    try {
      const payload = {
        user_id: userInfo.id,
        user_name: userInfo.name,
        user_email: userInfo.email,
        dashboard_id: selectedId, //id
      };
      await deleteDashboardV2(payload);

      const updated = { ...chatData };

      Object.keys(updated).forEach((group) => {
        updated[group] = updated[group].filter((item) => item !== deleteItem);
      });

      setChatData(updated);
      setOpenDeleteDialog(false);
      setSuccessMessage("Dashboard Deleted Successfully");
      setSuccess(true);
      setError("");
      await fetchDashboardCards();
    } catch (error) {
      console.error("Delete failed", error);
      setError("Failed to delete dashboard. Please try again.");
    }
  };
useEffect(() => {
  if (location.state?.skipInitialFetch) {
    if (Array.isArray(location.state.cards)) {
      setCards(location.state.cards);
    }

    setLoading(false);
    window.history.replaceState({}, document.title);
    return;
  }

  fetchDashboardCards();
}, [fetchDashboardCards]);

  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "calc(100vh - 150px)",
        }}
      >
        <CircularProgress />
      </Box>
    );
  const handleNewChat = () => {
    navigate("/samarth/chat", { replace: true });
  };

  return (
    <Box className={styles.MyDashboardContainer} sx={{ overflowX: "hidden" }}>
      <Box sx={{ display: "flex", flex: 1, minHeight: 0, minWidth: 0 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
            pr: "24px",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={{ sm: 1, md: 2, lg: 3 }}
          >
            <Box display="flex" gap={3}>
              <button
                className={styles.MyDashboardBtn}
                onClick={() => navigate("/samarth/chat", { replace: true })}
              >
                {view !== "dashboards" && (
                  <Box
                    component="img"
                    src={BackArrow}
                    mr={1}
                    sx={{
                      width: { sm: 16, md: 20, lg: 24 },
                      height: { sm: 16, md: 20, lg: 24 },
                    }}
                  />
                )}
                My Dashboard
              </button>
              {cards.length > 0 && (
                <button
                  className={styles.createNewDashboard}
                  onClick={handleOpenDialog}
                >
                  Create New Dashboard
                </button>
              )}
            </Box>
            {view === "dashboards" ? (
              <Box display="flex" gap="8px" alignItems="center">
                <button
                  className={styles.NewChat}
                  onClick={() => {
                    if (
                      conversationId !== null &&
                      conversationId !== undefined
                    ) {
                      localStorage.setItem("convId", conversationId);
                    }
                    navigate("/samarth/dashoard-list", {
                      state: { skipInitialFetch: true, cards },
                    });
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        md: "10px !important",
                        lg: "14px !important",
                      },
                      fontWeight: 400,
                    }}
                  >
                    Expand
                  </Typography>
                  <Box
                    component="img"
                    src={ExpandIcon}
                    className={styles.smallIconStyle}
                    sx={{
                      border: "1px solid #0066CC",
                      borderRadius: "50%",
                      padding: "4px",
                      "&:hover": {
                        backgroundColor: "#C2E0FF",
                        borderRadius: "50%",
                        border: "1px solid #0066CC",
                      },
                    }}
                  />
                </button>
              </Box>
            ) : (
              <>
                {!showHistory && (
                  <Box display="flex" gap="8px" alignItems="center">
                    {/* New Chat Button (already has text) */}
                    <button
                      className={styles.NewChat}
                      onClick={() => {
                        navigate("/samarth/chat");
                        localStorage.removeItem("convId");
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            md: "10px !important",
                            lg: "14px !important",
                          },
                          fontWeight: 400,
                        }}
                      >
                        New Chat
                      </Typography>
                      <Box
                        component="img"
                        src={Edit}
                        className={styles.smallIconStyle}
                        sx={{
                          "&:hover": {
                            backgroundColor: "#C2E0FF",
                            borderRadius: "50%",
                          },
                        }}
                      />
                    </button>

                    {/* Slider Icon with Hover Text */}
                    <Box
                      sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#C2E0FF",
                          borderRadius: "50%",
                        },

                        "&:hover .historyLabel": {
                          opacity: 1,
                          visibility: "visible",
                          transform: "translateX(0)",
                        },
                      }}
                    >
                      {/* Hover Text */}
                      <Typography
                        className="historyLabel"
                        sx={{
                          position: "absolute",
                          right: { md: "70%", lg: "120" },
                          mr: 7,
                          fontSize: { md: "10px", lg: "14px" },
                          fontWeight: 400,
                          color: "#0066CC",
                          opacity: 0,
                          visibility: "hidden",
                          transform: "translateX(10px)",
                          transition: "all 0.25s ease",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Prompts & History
                      </Typography>

                      {/* Icon */}
                      <Box
                        component="img"
                        src={SliderIcon}
                        className={styles.smallIconStyle}
                        onClick={async () => {
                          setShowHistory((prev) => !prev);
                          if (!hasLoadedConversations) {
                            setPage(1);
                            setHasNext(true);
                            setConversationList([]);
                            await fetchConversations(1, true);
                            setHasLoadedConversations(true);
                          }
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        "&:hover": {
                          backgroundColor: "#C2E0FF",
                          borderRadius: "50%",
                        },

                        "&:hover .historyLabel": {
                          opacity: 1,
                          visibility: "visible",
                          transform: "translateX(0)",
                        },
                      }}
                    >
                      {/* Hover Text */}
                      <Typography
                        className="historyLabel"
                        sx={{
                          position: "absolute",
                          right: { md: "70%", lg: "120" },
                          mr: 12,
                          fontSize: { md: "10px", lg: "14px" },
                          fontWeight: 400,
                          color: "#0066CC",
                          opacity: 0,
                          visibility: "hidden",
                          transform: "translateX(10px)",
                          transition: "all 0.25s ease",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Minimize
                      </Typography>

                      {/* Icon */}
                      <Box
                        component="img"
                        src={ExpandLessIcon}
                        className={styles.smallIconStyle}
                        sx={{
                          border: "1px solid #0066CC",
                          borderRadius: "50%",
                          padding: "4px",
                          "&:hover": {
                            backgroundColor: "#C2E0FF",
                            borderRadius: "50%",
                            border: "1px solid #0066CC",
                          },
                        }}
                        onClick={() => {
                          const storedConvId = localStorage.getItem("convId");

                          const convId =
                            conversationId &&
                            conversationId !== "null" &&
                            conversationId !== "chat"
                              ? conversationId
                              : storedConvId &&
                                  storedConvId !== "null" &&
                                  storedConvId !== "chat"
                                ? storedConvId
                                : null;

                          navigate(
                            convId
                              ? `/samarth/chat/${convId}`
                              : "/samarth/chat",
                            {
                              state: {
                                view: "dashboards",
                                conversationId: convId,
                                skipInitialFetch: true,
                                cards,
                              },
                              replace: true,
                            },
                          );

                          onDashboardSelect?.();
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </>
            )}
          </Box>
          <Box
            sx={{
              height:
                view === "dashboards"
                  ? {
                      md: "calc(100vh - 120px)",
                      lg: "calc(100vh - 160px)",
                    }
                  : "calc(100vh - 150px)",
              overflowY: "auto",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              padding: 2,
            }}
          >
            <Grid container spacing={2}>
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                    width: "100%",
                  }}
                >
                  <CircularProgress size={40} />
                </Box>
              ) : cards.length > 0 ? (
                cards.map((card) => (
                  <Grid
                    item
                    xs={12}
                    sm={view === "dashboards" ? 12 : 6}
                    md={view === "dashboards" ? 6 : 4}
                    key={card.id}
                  >
                    <Box
                      className={styles.dashboardBox}
                      onClick={() => {
                        if (location.pathname !== "/samarth/dashoard-list") {
                          onDashboardSelect?.(card.id);
                        } else {
                          navigate(`/samarth/mydashoard/${card.id}`, {
                            state: { view: "dashboards" },
                          });
                        }
                      }}
                      sx={{ cursor: "pointer" }}
                    >
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={{ sm: 1, md: 2, lg: 3 }}
                      >
                        <Typography
                          sx={{
                            fontSize: { xs: "10px", md: "12px", lg: "16px" },
                          }}
                        >
                          {card.title}
                        </Typography>

                        <IconButton
                          className={`${styles.menuButton} ${
                            selectedId === card.id && anchorEl
                              ? styles.menuButtonActive
                              : ""
                          }`}
                          sx={{
                            p: 0,
                            background: "#F8FBFC",
                            backdropFilter: "blur(100px)",
                          }}
                          onClick={(e) => openMenu(e, card.id)}
                        >
                          <Box
                            component="img"
                            src={MenuIcon}
                            sx={{
                              transform: "rotate(90deg)",
                              height: { sm: "16px", md: "18px", lg: "24px" },
                              width: { sm: "16px", md: "18px", lg: "24px" },
                            }}
                          />
                        </IconButton>
                      </Box>

                      <Box className={styles.cardData}>
                        {card.count > 0 ? (
                          <Box
                            component="img"
                            src={DashboardFilled}
                            sx={{
                              width: "100%",
                            }}
                          />
                        ) : (
                          <Box
                            component="img"
                            src={DashboardDefault}
                            sx={{
                              width: "100%",
                            }}
                          />
                        )}
                      </Box>
                    </Box>
                  </Grid>
                ))
              ) : (
                <Box
                  textAlign="center"
                  sx={{
                    // maxWidth: "1177px",
                    // width: "100%",
                    m: "0 auto",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: {
                      sm: "14px",
                      md: "16px",
                      lg: "32px",
                    },
                    height:
                      view === "dashboards"
                        ? {
                            md: "calc(100vh - 120px)",
                            lg: "calc(100vh - 160px)",
                          }
                        : "calc(100vh - 150px)",
                  }}
                >
                  <Box
                    sx={{
                      minHeight: { xs: 100, md: 120, lg: 160 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box component="img" src={BotIcon} />{" "}
                  </Box>
                  <Typography className={styles.textheading}>
                    Create your first dashboard
                  </Typography>
                  <Typography className={styles.textFeild}>
                    Build a dashboard to track performance, losses, and risks.
                    Samarth AI can help you summarize and analyze it once
                    created.
                  </Typography>
                  <button
                    className={styles.createDashboard}
                    onClick={handleOpenDialog}
                  >
                    Create New Dashboard
                  </button>
                </Box>
              )}
            </Grid>
          </Box>
        </Box>
        <PromtsHistory
          open={showHistory}
          onClose={() => setShowHistory(false)}
          conversationList={conversationList}
          fetchConversations={fetchConversations}
          loadMore={loadMore}
          handleNewChat={handleNewChat}
          fetchConversationId={fetchConversationId}
        />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        sx={MenuStyles}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleRename}>
          {" "}
          <Box
            component="img"
            src={RenameIcon}
            mr={1}
            sx={{
              width: { md: 16, lg: 24 },
              height: { md: 16, lg: 24 },
            }}
          />{" "}
          Rename
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>
          <Box
            component="img"
            src={DeleteIcon}
            mr={1}
            sx={{
              width: { md: 16, lg: 24 },
              height: { md: 16, lg: 24 },
            }}
          />{" "}
          Delete
        </MenuItem>
      </Menu>
      <DeleteChatDialog
        open={openDeleteDialog}
        title="Are you sure you want to delete this Dashboard?"
        description="This action cannot be undone."
        confirmText="Delete"
        cancelText="Cancel"
        onClose={() => setOpenDeleteDialog(false)}
        onConfirm={confirmDelete}
      />
      <RenameDialog
        open={openRenameDialog}
        initialValue={editValue}
        onClose={() => setOpenRenameDialog(false)}
        onSave={handleSaveRename}
      />
      <FeedbackDialog
        open={openDialog}
        onClose={handleCloseDialog}
        title="Create New Dashboard"
        feedbackComment={newDashboardName}
        setFeedbackComment={setNewDashboardName}
        onSubmit={handleCreateDashboard}
        loading=""
        buttonLabel="Create Dashboard"
        minRows={1}
        placeholder="Enter Dashboard"
      />
      <ReusableSnackbar
        open={success}
        message={successMessage}
        type="success"
        onClose={() => setSuccess(false)}
      />

      <ReusableSnackbar
        open={!!error}
        message={error}
        type="error"
        onClose={() => setError("")}
      />
    </Box>
  );
}
